import Chevron from "../../../assets/icons/Chevron";

export const FilterDropdown = ({
  value,
  options,
  onChange,
  placeholderText = "Any" // Default placeholder text
}: {
  value: string;
  options: string[];
  onChange: (value: string) => void;
  placeholderText?: string; // New prop for placeholder text
}) => (
  <article className="relative flex w-full bg-white">
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      className="relative z-10 w-full appearance-none rounded-lg border border-[#D1D5DB] bg-transparent py-3 pl-4 pr-10 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#010D2C]/20"
    >
      {options.map((option, index) => (
        <option key={index} value={option}>
          {option === "" ? placeholderText : option}
        </option>
      ))}
    </select>

    <Chevron className="absolute right-4 top-1/2 -translate-y-1/2 z-0 h-4 w-4 stroke-gray-800 pointer-events-none" />
  </article>
);

export default FilterDropdown;
